import { useEffect, useState } from 'react';

interface Options {
  rootMargin?: string;
  threshold?: number | number[];
}

export function useScrollSpy(ids: string[], options: Options = {}): string | null {
  const [activeId, setActiveId] = useState<string | null>(null);

  useEffect(() => {
    if (ids.length === 0) return;
    const elements = ids
      .map((id) => document.getElementById(id))
      .filter((el): el is HTMLElement => el !== null);

    if (elements.length === 0) return;

    const observer = new IntersectionObserver(
      (entries) => {
        for (const entry of entries) {
          if (entry.isIntersecting) {
            setActiveId(entry.target.id);
            return;
          }
        }
      },
      { rootMargin: options.rootMargin ?? '-30% 0px -55% 0px', threshold: options.threshold ?? 0 },
    );

    elements.forEach((el) => observer.observe(el));
    return () => observer.disconnect();
  }, [ids.join('|'), options.rootMargin]); // eslint-disable-line react-hooks/exhaustive-deps

  return activeId;
}
